import React, { FC, memo } from 'react';
import clsx from 'clsx';
import { Plan } from '../interfaces/PlanIntrfaces';

interface PlansCheckboxProps {
  checkedValue: boolean;
  onCheckedChange: (data: any) => void;
  plan?: Plan | {};
  showCheckbox: boolean;
}

const PlansCheckbox: FC<PlansCheckboxProps> = ({ checkedValue, onCheckedChange, plan = {}, showCheckbox }) => {
  const onCheckBoxCheked = () => onCheckedChange({ newCheckedValue: !checkedValue, plan: plan });

  if (!showCheckbox) {
    return <div />;
  }

  return (
    <div className="field-with-icons my-4 mt-4 relative rounded w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 justify-self-center">
      <input
        tabIndex={-1}
        type="checkbox"
        className="opacity-0 w-5 h-5 absolute focus:outline-none active:outline-none"
        checked={checkedValue}
        onChange={onCheckBoxCheked}
      />
      <svg
        viewBox="0 0 20 20"
        className={clsx('fill-current w-4 h-4 text-primary-500 pointer-events-none', !checkedValue && 'hidden')}
      >
        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
      </svg>
    </div>
  );
};

export default memo(PlansCheckbox);
